<template src="./Edit.html"></template>

<script>
// import { showAlert } from "@/utils/helpers";

export default {
    props: {
        itemId: {
            type: Number,
            required: true,
        },
    },

    created() {
        this.$store
            .dispatch("patients/getForEdit", this.itemId)
            .then((res) => {
                this.patient = res;
            }).catch(() => { });
    },
    computed: {
    },
    data() {
        return {
            patient: {
                firstName: null,
                lastName: null,
                email: null,
                phone: null,
                date: null,
            },

        };
    },
    methods: {
        confirm() {
            this.$store
                .dispatch("patients/edit", { id: this.itemId, payload: this.patient })
                .then(() => {
                    this.back();
                })
                .catch(() => { });
        },
        allowedDates(val) {
            const today = new Date();
            today.setFullYear(today.getFullYear() - 15);
            const date = new Date(val);
            return date < today;
        },
        back() {

            this.$emit("back");
        },
    },
};
</script>